import ApiInterface from "../interface/ApiInterface";
import { APIResponse } from "./ApprenticeServices";

export default class ApprenticeModuleContentAccess {
    public async registerContentAccess(payload: RegisterContentAccessPayload): Promise<APIResponse<boolean>> {

        return await ApiInterface.post("/ApprenticeModuleContentAccess/Register", payload).then(response => {
            return response.data;
        }).catch(err => {
            console.log(err);
        })
    }
}

export interface RegisterContentAccessPayload {
  courseId: string,
  moduleId: string,
  moduleContentId: string
}